<h2 mat-dialog-title class="text-center" style="font-weight: 800;">{{(data?.title) ? data.title : 'Confirmation'}}</h2>
<mat-dialog-content>
  <!-- <p class="text-start" style="max-width: 350px;">{{(data?.text) ? data.text : 'Please, confirm your action'}}</p> -->
  <p class="text-start" style="max-width: 350px;" [innerHTML]="data?.text ? data.text : 'Please, confirm your action'"></p>
</mat-dialog-content>
<div mat-dialog-actions class="d-flex justify-content-center">
  <button mat-flat-button color="primary" [mat-dialog-close]="true">{{(data?.ok) ? data.ok : 'Ok'}}</button>
  <button mat-stroked-button [mat-dialog-close]="false">{{(data?.cancel) ? data.cancel : 'Cancel'}}</button>
</div>